<template>
    <div
        :style="{
            '--color': color || DEFAULT_COLOR,
            '--stroke': strokeColor || DEFAULT_STROKE
        }"
        class="svg-loader"
    >
        <div class="flex-center p-2">
            <svg
                class="logo1 w-20 sm:w-32 h-20 sm:h-32 aspect-square"
                viewBox="0 0 36 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M29.0289 27.7824V27.9429C29.0616 28.2637 29.225 28.5203 29.4866 28.7128L30.6634 29.579C31.1864 29.964 31.9383 29.8677 32.3306 29.3544C34.292 26.7558 35.3381 23.7081 35.3381 20.5321C35.3381 17.356 34.3247 14.2441 32.3633 11.6776C31.971 11.1643 31.2192 11.0681 30.6961 11.453L29.5193 12.3192C29.2578 12.5117 29.0943 12.7684 29.0616 13.0892V13.2496C29.0616 13.5062 29.1597 13.7308 29.2904 13.9554C30.7615 15.8803 31.546 18.158 31.546 20.5321C31.546 22.9061 30.7615 25.1838 29.2904 27.1087C29.1269 27.2691 29.0289 27.5258 29.0289 27.7824Z"
                    fill="currentColor"
                />
                <path
                    d="M24.1254 24.2855V24.4459C24.1581 24.7347 24.3542 25.0234 24.5831 25.2159L25.5311 25.8896C26.0541 26.2746 26.806 26.1784 27.1983 25.6651C29.4212 22.7456 29.4212 18.2542 27.1983 15.3349C26.806 14.8216 26.0541 14.7253 25.5311 15.1103L24.5831 15.784C24.3216 15.9765 24.1581 16.2331 24.1254 16.5539V16.7143C24.1254 16.971 24.2235 17.2276 24.3542 17.4201C25.6945 19.1525 25.6945 21.8473 24.3542 23.6118C24.2235 23.8043 24.1254 24.0289 24.1254 24.2855Z"
                    fill="currentColor"
                />
                <path
                    d="M34.5208 32.1776C34.0304 31.6964 33.2132 31.6964 32.7228 32.1776C29.5519 35.2895 25.3349 36.9898 20.889 36.9898C11.6377 36.9577 4.11897 29.579 4.11897 20.5C4.11897 11.421 11.6377 4.04226 20.889 4.04226C25.3349 4.04226 29.5519 5.74255 32.7228 8.85444C33.2132 9.33567 34.0304 9.33567 34.5208 8.85444L35.6322 7.76369C36.1226 7.28246 36.1226 6.44832 35.6322 5.99924C31.6767 2.11736 26.4463 0 20.881 0C9.34937 0 0 9.17528 0 20.5C0 31.8247 9.38205 41 20.889 41C26.4463 41 31.6767 38.8826 35.6322 35.0328C36.1226 34.5516 36.1226 33.7175 35.6322 33.2684L34.5208 32.1776Z"
                    fill="currentColor"
                />
                <path
                    d="M20.7582 22.4244C21.8415 22.4244 22.7196 21.5627 22.7196 20.4998C22.7196 19.4368 21.8415 18.5752 20.7582 18.5752C19.675 18.5752 18.7968 19.4368 18.7968 20.4998C18.7968 21.5627 19.675 22.4244 20.7582 22.4244Z"
                    fill="currentColor"
                />
            </svg>
        </div>
        <div class="flex-center">
            <svg
                class="logo2 w-48 h-24 sm:w-96"
                width="400px"
                height="100px"
                viewBox="0 0 154 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.9 0.499999L12.325 18H8.325L0.775 0.499999H5.15L10.475 13L15.875 0.499999H19.9ZM29.6164 18.3C27.7997 18.3 26.1581 17.9083 24.6914 17.125C23.2414 16.3417 22.0997 15.2667 21.2664 13.9C20.4497 12.5167 20.0414 10.9667 20.0414 9.25C20.0414 7.53333 20.4497 5.99167 21.2664 4.625C22.0997 3.24167 23.2414 2.15833 24.6914 1.375C26.1581 0.591666 27.7997 0.2 29.6164 0.2C31.4331 0.2 33.0664 0.591666 34.5164 1.375C35.9664 2.15833 37.1081 3.24167 37.9414 4.625C38.7747 5.99167 39.1914 7.53333 39.1914 9.25C39.1914 10.9667 38.7747 12.5167 37.9414 13.9C37.1081 15.2667 35.9664 16.3417 34.5164 17.125C33.0664 17.9083 31.4331 18.3 29.6164 18.3ZM29.6164 14.85C30.6497 14.85 31.5831 14.6167 32.4164 14.15C33.2497 13.6667 33.8997 13 34.3664 12.15C34.8497 11.3 35.0914 10.3333 35.0914 9.25C35.0914 8.16667 34.8497 7.2 34.3664 6.35C33.8997 5.5 33.2497 4.84167 32.4164 4.375C31.5831 3.89167 30.6497 3.65 29.6164 3.65C28.5831 3.65 27.6497 3.89167 26.8164 4.375C25.9831 4.84167 25.3247 5.5 24.8414 6.35C24.3747 7.2 24.1414 8.16667 24.1414 9.25C24.1414 10.3333 24.3747 11.3 24.8414 12.15C25.3247 13 25.9831 13.6667 26.8164 14.15C27.6497 14.6167 28.5831 14.85 29.6164 14.85ZM42.2352 0.499999H46.2852V18H42.2352V0.499999ZM58.8133 18.3C57.0299 18.3 55.4133 17.9167 53.9633 17.15C52.5299 16.3667 51.3966 15.2917 50.5633 13.925C49.7466 12.5417 49.3383 10.9833 49.3383 9.25C49.3383 7.51667 49.7466 5.96667 50.5633 4.6C51.3966 3.21667 52.5299 2.14167 53.9633 1.375C55.4133 0.591666 57.0383 0.2 58.8383 0.2C60.3549 0.2 61.7216 0.466666 62.9383 1C64.1716 1.53333 65.2049 2.3 66.0383 3.3L63.4383 5.7C62.2549 4.33333 60.7883 3.65 59.0383 3.65C57.9549 3.65 56.9883 3.89167 56.1383 4.375C55.2883 4.84167 54.6216 5.5 54.1383 6.35C53.6716 7.2 53.4383 8.16667 53.4383 9.25C53.4383 10.3333 53.6716 11.3 54.1383 12.15C54.6216 13 55.2883 13.6667 56.1383 14.15C56.9883 14.6167 57.9549 14.85 59.0383 14.85C60.7883 14.85 62.2549 14.1583 63.4383 12.775L66.0383 15.175C65.2049 16.1917 64.1716 16.9667 62.9383 17.5C61.7049 18.0333 60.3299 18.3 58.8133 18.3ZM82.3232 14.75V18H68.7732V0.499999H81.9982V3.75H72.7982V7.55H80.9232V10.7H72.7982V14.75H82.3232ZM101.596 0.499999V18H98.2707L89.5457 7.375V18H85.5457V0.499999H88.8957L97.5957 11.125V0.499999H101.596ZM109.361 3.8H103.761V0.499999H119.011V3.8H113.411V18H109.361V3.8ZM134.74 14.75V18H121.19V0.499999H134.415V3.75H125.215V7.55H133.34V10.7H125.215V14.75H134.74ZM149.113 18L145.738 13.125H145.538H142.013V18H137.963V0.499999H145.538C147.088 0.499999 148.429 0.758332 149.563 1.275C150.713 1.79167 151.596 2.525 152.213 3.475C152.829 4.425 153.138 5.55 153.138 6.85C153.138 8.15 152.821 9.275 152.188 10.225C151.571 11.1583 150.688 11.875 149.538 12.375L153.463 18H149.113ZM149.038 6.85C149.038 5.86667 148.721 5.11667 148.088 4.6C147.454 4.06667 146.529 3.8 145.313 3.8H142.013V9.9H145.313C146.529 9.9 147.454 9.63333 148.088 9.1C148.721 8.56667 149.038 7.81667 149.038 6.85Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    </div>
</template>

<script setup lang="ts">

const DEFAULT_STROKE = '#D34C4C'
const DEFAULT_COLOR = 'transparent'

defineProps<{
    color?: string
    strokeColor?: string
}>()

</script>

<style scoped lang="scss">
    .svg-loader {
        overflow: visible;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .logo1 {
            color: var(--color, transparent);
            //fill: red;
            stroke-dasharray: 60px;
            stroke-width: 1px;
            //stroke-opacity: 1;
            /*<-- Play with this number until it look cool */
            stroke: var(--stroke, #D34C4C);
            animation: svgLoad 1.5s infinite linear alternate-reverse;
        }
        .logo2 {
            color: var(--color, transparent);
            //fill: red;
            stroke-dasharray: 120px;
            stroke-width: 1px;
            //stroke-opacity: 1;
            /*<-- Play with this number until it look cool */
            stroke: var(--stroke, #D34C4C);
             animation: svgLoad 1.5s infinite linear alternate-reverse;
        }

        @keyframes svgLoad {
            0% {
                stroke-dashoffset: 0;
            }

            100% {
                stroke-dashoffset: 100px;
                /* <-- This number should always be 10 times the number up there*/
            }
        }
    }
</style>
